import { isLive, isPremium } from "./Utilities";
import { getAgencyData, getUserData } from "./Storage";

// Global feature toggles. Flip to true to roll out.
export const SHOW_BUSINESS_GOALS = false;
export const SHOW_COMMUNITY = true;
export const SHOW_CONTACT_CARD = true;
export const SHOW_VIEW_COUNTS_IN_FEED = false;

// New nomenclature for Feature flags names.
// <module name>_<verb>_<noun(s)>
//For example : TASK_ALLOW_FILEUPLOAD, CONN_SHOW_CONTACT_CARD
//CONN stands for Connections, INQ stands for Inquiries, Task stands for Tasks, etc.

export const COMMUNITY_ALLOW_MULTIPLE_IMAGES = false;
export const COMMUNITY_ALLOW_MULTIPLE_COMMENTS = false;

// Array of AgencyIDs enabled for testing / previewing experimental features
// export const TESTING_AGENCIES = [1, 52, 41344, 40900];
export const TESTING_AGENCIES = [1,3,52,86,10712,41381,41344,40900,41415];

export const SHOW_LISTING = () => {

  return true;
  try {
    const agencyData = getAgencyData();

    const agencyID = Number(
      agencyData?.AgencyID ?? agencyData?.agencyID
    );
    return TESTING_AGENCIES.includes(agencyID);
  } catch (err) {
    console.error("Error evaluating SHOW_LISTING:", err);
  }
  return false;
};

/**
 * Checks whether Integrations and Excel Imports should be visible.
 * Returns true if agency is premium or created before 7th September 2026.
 * Returns false otherwise.
 */
export const canShowImportInquiries = () => {
  try {
    if (isPremium()) {
      return true;
    }

    const agencyData = getAgencyData();
    const userData = getUserData();
    const createdDTStr = agencyData?.CreatedDT || agencyData?.createdDT || userData?.CreatedDT || userData?.createdDT;

    if (createdDTStr) {
      const createdDate = new Date(createdDTStr);
      if (!isNaN(createdDate.getTime())) {
        // Cutoff: 7th September 2026 (Month index 8 in JS Date)
        const cutoffDate = new Date(2026, 8, 7);
        cutoffDate.setHours(0, 0, 0, 0);

        const agencyDate = new Date(createdDate);
        agencyDate.setHours(0, 0, 0, 0);

        if (agencyDate < cutoffDate) {
          return true;
        }
      }
    }
    return false;
  } catch (err) {
    console.error("Error evaluating canShowImportInquiries:", err);
  }

  return false;
};

export const SHOW_EXPENSES = () => {
  try {
    const agencyData = getAgencyData();
    const allowedAgencyID = 1;
    return Number(agencyData?.AgencyID ?? agencyData?.agencyID) === allowedAgencyID;
  } catch (err) {
    console.error("Error evaluating SHOW_EXPENSES:", err);
  }
  return false;
};
export const SHOW_IMPORT_INQUIRIES = true;
export const SHOW_QUICK_TASK_AI = false; // isLive() ? false : true;
export const SHOW_SHARE_APP = true;